export default __webpack_public_path__ + "locales/pl/ConvertDialog.json?hash=4c1df0c0570618f579016ad9186ff15f";